// Total verbs the Verb Conjugation page lists: the entries with a verbType across
// public/vocab-data/n1-n5.json (the pool ConjugationPage.tsx filters from), minus any
// N5/N4 entry hidden by hiddenVocabulary.ts (NIH-282; none today) and any on the
// exclusion list in verbExceptions.ts (empty today). After the NIH-281 rebuild that is
// 2,703 verb-tagged entries (N5 128, N4 240, N3 522, N2 620, N1 1,193; NIH-293 added 失礼). Kept as a
// constant so the homepage progress bar doesn't have to download every level's word
// list just to count them - verbTotal.test.ts fails if the data files, the hidden list
// or the exclusion list drift.
export const VERB_TOTAL = 2703;
